import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { PayOptionInfo, OtherActions } from './components';
import { ItemClassPreview, LessonPreview } from "components";

const useStyles = makeStyles(theme => ({
  root: {},
  card: {
    marginBottom: theme.spacing(3),
  }
}));

const Summary = props => {
  const { className, handleDelete, ...rest } = props;
  const model = useSelector(state => state.models.pay_option);

  const classes = useStyles();

  if (!model) {
    return null;
  }

  return (
    <Grid {...rest} className={clsx(classes.root, className)} container spacing={3}>
      <Grid item lg={4} md={6} xl={3} xs={12}>
        <PayOptionInfo className={classes.card} />
        <ItemClassPreview itemClass={model.item_class} className={classes.card} />
      </Grid>
      <Grid item lg={4} md={6} xl={3} xs={12}>
        <LessonPreview lessonId={model.lesson_id} className={classes.card} />
        <OtherActions handleDelete={handleDelete} className={classes.card} />
      </Grid>
    </Grid>
  );
};

Summary.propTypes = {
  className: PropTypes.string
};

export default Summary;
